<template>
  <div id="selectCompany">
    <div v-if="select">
      <div class="select">
        <a>
          <div>
            <div class="d-flex align-items-center" @click="ShowDropdown()">
              <div class="selectCompany">
                <div class="imgCompany">
                  <img :src="select.logoUrl + `?ver=${imgVersion}`" />
                </div>
                <div>
                  <p class="crop merchantName" :title="GetMerchantName(select)">
                    {{ GetMerchantName(select) }}
                    <i class="icon-arrow-bropdown"></i>
                  </p>
                  <div class="merchantCode" @click="(CopyMerchantCode(select.code), $event.stopImmediatePropagation())">
                    <p>Code: {{ select.code }}</p>
                    <i class="fas fa-copy"></i>
                  </div>
                  <div
                    @click="(RedirectToBillingSetting(select.merchantId), $event.stopImmediatePropagation())"
                    class="peakageBox"
                  >
                    <span
                      :class="[
                        'status',
                        `peakage${
                          select.package == packageType.Trial || select.isSample
                            ? 4
                            : GetExpireDateModel(
                                  select.createDateTime,
                                  select.expireDateTime,
                                  select.isSample,
                                  select.package
                                ).expireDate
                              ? 1
                              : select.package
                        }`,
                      ]"
                      >{{ select.isSample ? "PRO Plus" : select.packageName }}</span
                    >
                    <p class="ml-2">
                      {{
                        GetExpireDateModel(
                          select.createDateTime,
                          select.expireDateTime,
                          select.isSample,
                          select.package,
                          isCurrentMerchant
                        ).title
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div class="dropdowns" v-click-outside="hide">
        <div :class="'overflow ' + classBox" :style="'display:' + displayBox">
          <div class="box" :style="'display:' + displayText">
            <div class="selectThis">
              <div :class="classText">
                <div class="companyItem">
                  <div class="imgCompany">
                    <img :src="select.logoUrl + `?ver=${imgVersion}`" />
                  </div>
                  <div class="merchantName">
                    <p class="textBold">
                      {{ GetMerchantName(select) }}
                    </p>
                    <span
                      :class="[
                        'status',
                        `peakage${
                          select.package == packageType.Trial || select.isSample
                            ? 4
                            : GetExpireDateModel(
                                  select.createDateTime,
                                  select.expireDateTime,
                                  select.isSample,
                                  select.package
                                ).expireDate
                              ? 1
                              : select.package
                        }`,
                      ]"
                      >{{ select.isSample ? "PRO Plus" : select.packageName }}</span
                    >
                    <span class="otherInfo">Code: {{ select.code }}</span>
                    <span class="otherInfo">
                      <i class="fas fa-user"></i>
                      {{ GetAuthorityRole(select.role.authorityRole, select.role.isSuperUser) }}
                    </span>
                  </div>
                </div>
                <div class="mx-3 mb-3" @click="(OpenInputSearch(), $event.stopImmediatePropagation())">
                  <InputSearchCompany v-model="inputSearch" :showOnly="true" width="100%" />
                </div>
              </div>
              <div class="iconArrow">
                <i class="icon-arrow-bropdown"></i>
              </div>
            </div>
            <div class="selectList" ref="listBox">
              <div
                v-for="(company, index) in listDisplay"
                :key="index"
                @click="(DoSelectMerchant(company.merchantId), (showDropdown = false))"
                v-show="select.merchantId !== company.merchantId && CheckCanShowItem(company)"
              >
                <div v-if="company.role" :class="classText">
                  <div class="companyItem">
                    <div class="ml-2">
                      <div
                        v-if="getFavoriteMerchantList.length < 5 || company.isFavorite"
                        @click="
                          (UpdateMerchantFavoriteByMerchantId(company.merchantId), $event.stopImmediatePropagation())
                        "
                      >
                        <i v-if="company.isFavorite" class="fas fa-star favorite"></i>
                        <i v-else class="far fa-star favorite-hover"></i>
                      </div>
                      <div v-else @click="$event.stopImmediatePropagation()" disabled>
                        <i class="far fa-star favorite-disable"></i>
                      </div>
                    </div>
                    <div class="imgCompany">
                      <img :src="company.logoUrl + `?ver=${imgVersion}`" />
                    </div>
                    <div class="merchantName">
                      <p :title="GetMerchantName(company)" class="textBold merchantName-crop">
                        {{ GetMerchantName(company) }}
                      </p>
                      <span
                        :class="[
                          'status',
                          `peakage${
                            company.package == packageType.Trial
                              ? 4
                              : GetExpireDateModel(
                                    company.createDateTime,
                                    company.expireDateTime,
                                    company.isSample,
                                    company.package
                                  ).expireDate
                                ? 1
                                : company.package
                          }`,
                        ]"
                        >{{ company.isSample ? "PRO Plus" : company.packageName }}</span
                      >
                      <span class="otherInfo">Code: {{ company.code }}</span>
                      <span class="otherInfo">
                        <i class="fas fa-user"></i>
                        {{ GetAuthorityRole(company.role.authorityRole, company.role.isSuperUser) }}
                      </span>
                    </div>
                  </div>
                </div>
                <div :class="classText" v-else>
                  <div class="skeleton py-2 px-2">
                    <div class="img-skeleton">
                      <div>
                        <Skeleton height="45px" width="45px" />
                      </div>
                    </div>
                    <div>
                      <p class="textBold mb-2">
                        {{ GetMerchantName(company) }}
                      </p>
                      <Skeleton />
                    </div>
                  </div>
                </div>
              </div>

              <div :class="['allcompany', classText]" @click="$router.push({ name: 'selectlist' })">
                <p class="textBlue">
                  {{ $t("All_Organization") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { AuthorityRole, LoadingStatusType, Locales, Package, TypeComponentNoti } from "@/enums/enums";
import { SetMerchantForDisplay } from "@/helper/merchantHelper";
import { MerchantInFoModel } from "@/model/merchant/MerchantInFoModel";
import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import InputSearchCompany from "@/views/selectCompany/InputSearchCompany.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreLogIn = namespace("LogIn");
const StoreAlert = namespace("Alert");

@Component({ components: { InputSearchCompany } })
export default class SelectCompany extends Vue {
  public inputSearch = "";
  public totalMerchantDisplayWithFavorite = 0;
  public showDropdown = false;
  public count = 0;
  public classBox = "";
  public classText = "";
  public displayText = "none";
  public displayBox = "none";
  private listDisplay: any = [];
  private listMerchant: Array<MerchantInFoModel> = [];
  private listFilterMerchant: Array<MerchantInFoModel> = [];
  private listFavoriteMerchant: Array<MerchantInFoModel> = [];
  private listFilterFavoriteMerchant: Array<MerchantInFoModel> = [];
  private listFilterFavoriteMerchantForMap = new Map();
  public select: any = null;
  public packageType = Package;
  public countDownTime: any = "0";
  public isCurrentMerchant = true;
  public imgVersion = new Date().getTime();
  private isTimeoutInputSearch = 0;
  private isTimeoutHandleScroll = 0;
  private merchantIdListIsLoading: any = [];

  @StoreLogIn.Getter
  private getMerchant!: SelectedMerchantModel;
  @StoreLogIn.Getter
  private getMerchantList!: Array<MerchantInFoModel>;
  @StoreLogIn.Getter
  private getMerchantListLoadingStatus!: LoadingStatusType;
  @StoreLogIn.Getter
  private getFavoriteMerchantList!: any;
  @StoreLogIn.Getter
  private getFavoriteMerchantListLoadingStatus!: LoadingStatusType;

  @StoreAlert.Action
  private SetAlertMessage!: (input: any) => void;
  @StoreLogIn.Action
  private DoGetMerchantList!: () => void;
  @StoreLogIn.Action
  private DoGetFavoriteMerchant!: () => void;
  @StoreLogIn.Action
  private DoGetMerchantModelById!: (merchantId: number) => Promise<SelectedMerchantModel>;
  @StoreLogIn.Action
  private DoDeleteFavoriteMerchant!: (merchantId: number) => void;
  @StoreLogIn.Action
  private DoUpdateFavoriteMerchant!: (merchantId: number) => void;

  created() {
    this.select = this.getMerchant;
    this.DoCheckAndCountDown();
  }

  mounted() {
    const listBox: any = this.$refs.listBox;
    listBox.addEventListener("scroll", this.HandleScroll);
  }

  @Watch("showDropdown")
  showDropdownChanged() {
    if (this.showDropdown) {
      this.classBox = "boxIn";
      this.classText = "textIn";
      this.displayBox = "";
      this.displayText = "";
    } else {
      this.classText = "textOut";
      setTimeout(() => {
        this.classBox = "boxOut";
        setTimeout(() => {
          this.displayText = "none";
          this.displayBox = "none";
        }, 240);
      }, 240);
    }
  }

  @Watch("inputSearch")
  inputSearchChanged() {
    clearTimeout(this.isTimeoutInputSearch);
    this.isTimeoutInputSearch = setTimeout(() => {
      const listBox: any = this.$refs.listBox;
      listBox.scroll({
        top: 0,
        behavior: "smooth",
      });
      this.SetListFilter();
      this.ResetDatalistDisplay();
    }, 250) as unknown as number;
  }

  @Watch("getMerchantListLoadingStatus")
  getMerchantListLoadingStatusChange(newValue: LoadingStatusType) {
    if (this.showDropdown) {
      this.listMerchant = this.getMerchantList;
      this.SetListFilter();
      this.ResetDatalistDisplay();
    }
  }

  @Watch("getFavoriteMerchantListLoadingStatus")
  getFavoriteMerchantListLoadingStatusChange(newValue: LoadingStatusType) {
    if (this.showDropdown) {
      if (newValue === LoadingStatusType.None) {
        this.DoGetFavoriteMerchant();
      } else if (newValue === LoadingStatusType.Success) {
        this.SetFavoriteMerchantModel();
      }
    }
  }

  public DoCheckAndCountDown() {
    if (
      this.GetExpireDateModel(
        this.select.createDateTime,
        this.select.expireDateTime,
        this.select.isSample,
        this.select.package
      ).isCountDownTime
    ) {
      this.CountDownTimer();
    }
  }

  public CountDownTimer() {
    this.countDownTime = this.CalculateTimeForCountDownExpirePackage();
    setTimeout(() => {
      this.CountDownTimer();
    }, 60000);
  }

  public CalculateTimeForCountDownExpirePackage() {
    const toDate = new Date();
    const tomorrow = new Date();
    tomorrow.setHours(24, 0, 0, 0);
    let diffMS = tomorrow.getTime() / 1000 - toDate.getTime() / 1000;
    const diffHr = Math.floor(diffMS / 3600);
    diffMS = diffMS - diffHr * 3600;
    const diffMi = Math.floor(diffMS / 60);
    diffMS = diffMS - diffMi * 60;
    const hours = diffHr < 10 ? "0" + diffHr : diffHr;
    return hours + ":" + (diffMi < 10 ? "0" + diffMi : diffMi);
  }

  public ShowDropdown() {
    this.showDropdown = true;
    this.count = 0;

    if (this.getMerchantListLoadingStatus === LoadingStatusType.None) {
      this.DoGetMerchantList();
    } else {
      this.listMerchant = this.getMerchantList;
    }

    if (this.getFavoriteMerchantListLoadingStatus === LoadingStatusType.None) {
      this.DoGetFavoriteMerchant();
    } else {
      this.SetFavoriteMerchantModel();
    }

    if (
      this.getMerchantListLoadingStatus === LoadingStatusType.Success &&
      this.getFavoriteMerchantListLoadingStatus === LoadingStatusType.Success
    ) {
      this.SetListFilter();
      this.ResetDatalistDisplay();
    }
  }

  public SetListFilter() {
    const text = this.inputSearch.toLowerCase();
    if (text) {
      this.listFilterMerchant = this.listMerchant.filter((item) => {
        if (item.merchantName) {
          return item.merchantName.toLowerCase().includes(text.toLowerCase());
        }
        return false;
      });

      this.listFilterFavoriteMerchant = this.listFavoriteMerchant.filter((item) => {
        if (item.merchantName) {
          return item.merchantName.toLowerCase().includes(text.toLowerCase());
        }
        return false;
      });
    } else {
      this.listFilterMerchant = this.listMerchant;
      this.listFilterFavoriteMerchant = this.listFavoriteMerchant;
    }
  }

  public DoSelectMerchant(merchantId: number) {
    window.location.href = `${window.location.origin}/home?emi=${merchantId.PeakEncryption()}`;
  }

  public RedirectToBillingSetting(merchantId: number) {
    window.open(`${process.env.VUE_APP_PeakAccount}setting/billing?emi=${merchantId.PeakEncryption()}&tdti=0`);
  }

  public GetExpireDateModel(
    createDateTime: any,
    expireDateTime: any,
    merchantIsSample: any,
    currentMainPackageId: any
  ) {
    let expireDate = new Date(expireDateTime);
    let dateTime = new Date();
    expireDate = new Date(expireDate.getFullYear(), expireDate.getMonth(), expireDate.getDate());
    dateTime = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate());
    if (currentMainPackageId == Package.Trial) {
      const createDate = new Date(createDateTime);
      expireDate = new Date(createDate.getFullYear(), createDate.getMonth(), createDate.getDate());
      expireDate.setDate(expireDate.getDate() + 30);
    }

    const Difference_In_Time = expireDate.getTime() - dateTime.getTime();
    const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

    const result: any = { title: "", expireDate: false, isCountDownTime: false };

    if (merchantIsSample) {
      result.title = this.$t("Create_Entity_Objective_list.For_Try_Out_Features");
    } else if (Difference_In_Days > 0) {
      result.title = this.$t("Remaining_X_days", { msg: Difference_In_Days.FormatMoney(0) });
    } else if (Difference_In_Days == 0) {
      result.title = this.$t("RemainingHours", { times: this.countDownTime });
      result.isCountDownTime = true;
    } else {
      result.title = this.$t("Click_This_To_Upgrade");
      result.expireDate = true;
    }

    return result;
  }

  public hide() {
    if (this.showDropdown) {
      this.count += 1;
      if (this.count == 2) {
        this.showDropdown = false;
        this.count = 0;
      }
    } else {
      this.count = 0;
    }
  }

  public GetMerchantName(merchant: any) {
    let merchantFullName = "";
    if (this.$i18n.locale == Locales.TH) {
      merchantFullName = merchant.merchantNameTh;
    } else {
      merchantFullName = merchant.merchantNameEng;
    }
    if (merchant.merchantBranchCode != "") {
      if (merchant.merchantBranchCode == "00000") {
        merchantFullName += " " + "(" + this.$t("head_quarter") + ")";
      } else {
        merchantFullName += " " + "(" + merchant.merchantBranchCode + ")";
      }
    }
    return merchantFullName;
  }

  public HandleScroll() {
    const listBox: any = this.$refs.listBox;
    const scrollHeight = listBox.scrollHeight;
    const scrollTop = listBox.scrollTop;
    const clientHeight = listBox.clientHeight;
    const scroll = scrollHeight - (scrollTop + clientHeight);
    if (scroll < 300) {
      if (this.totalMerchantDisplayWithFavorite < this.listFilterMerchant.length) {
        this.listDisplay.push(SetMerchantForDisplay(this.listFilterMerchant[this.totalMerchantDisplayWithFavorite]));
        this.totalMerchantDisplayWithFavorite += 1;
      }
    }

    clearTimeout(this.isTimeoutHandleScroll);
    this.isTimeoutHandleScroll = setTimeout(() => {
      const merchantIdList = [];
      for (const merchant of this.listDisplay) {
        if (!merchant.role && merchant.merchantId > 0) {
          merchantIdList.push(merchant.merchantId);
        }
      }
      if (merchantIdList.length > 0) {
        this.GetMerchantModel(merchantIdList);
      }
    }, 250) as unknown as number;
  }

  public ResetDatalistDisplay() {
    this.listDisplay = [];
    this.totalMerchantDisplayWithFavorite = 0;
    const merchantIdList = [];
    for (let i = 0; i < 10; i++) {
      if (i < this.listFilterMerchant.length) {
        this.totalMerchantDisplayWithFavorite += 1;
        this.listDisplay.push(SetMerchantForDisplay(this.listFilterMerchant[i]));
        merchantIdList.push(this.listFilterMerchant[i].merchantId);
      }
    }

    if (merchantIdList.length > 0) {
      this.GetMerchantModel(merchantIdList);
    }

    setTimeout(() => {
      this.SetFavoriteMerchantForMerchantList();
    }, 0);
  }

  public GetAuthorityRole(authorityRole: AuthorityRole, isSuperUser: boolean) {
    let role: any = "";
    if (isSuperUser) {
      role = this.$t("Super_Admin_Role");
    } else {
      switch (authorityRole) {
        case AuthorityRole.ViewOnly:
          role = this.$t("View_Only_Role");
          break;
        case AuthorityRole.PartialRights:
          role = this.$t("Partial_Role");
          break;
        case AuthorityRole.StandardRights:
          role = this.$t("Basic_Role");
          break;
        case AuthorityRole.Admin:
          role = this.$t("Admin_Role");
          break;
      }
    }

    return role;
  }

  public UpdateMerchantFavoriteByMerchantId(merchantId: number) {
    if (this.getFavoriteMerchantListLoadingStatus != LoadingStatusType.Loading) {
      if (this.getFavoriteMerchantList.length > 0) {
        const isHaveMerchantId = this.getFavoriteMerchantList.find((item: any) => item.merchantId === merchantId);
        if (isHaveMerchantId) {
          this.DoDeleteFavoriteMerchant(merchantId);
        } else {
          this.DoUpdateFavoriteMerchant(merchantId);
        }
      } else {
        this.DoUpdateFavoriteMerchant(merchantId);
      }
    }
  }

  public CopyMerchantCode(merchantCode: string) {
    navigator.clipboard.writeText(merchantCode);
    this.SetAlertMessage({
      alertMessage: this.$t("Merchant_Code_Copied_Alert"),
      typeMessage: TypeComponentNoti.Success,
    });
  }

  public async GetMerchantModel(merchantIdList: any) {
    const merchantIdListForLoad: any = merchantIdList.filter((x: any) => !this.merchantIdListIsLoading.includes(x));
    this.merchantIdListIsLoading = this.merchantIdListIsLoading.concat(merchantIdListForLoad);
    for (const merchantId of merchantIdListForLoad) {
      const merchantModel = await this.DoGetMerchantModelById(merchantId);
      if (merchantModel) {
        const indexMerchant = this.listDisplay.findIndex((x: any) => x.merchantId == merchantId && !x.isFavorite);
        if (indexMerchant > -1) {
          this.listDisplay.splice(indexMerchant, 1, { ...merchantModel, isFavorite: false });
        }
      }
      const indexMerchantIdIsLoading = this.merchantIdListIsLoading.findIndex((x: any) => x == merchantId);
      if (indexMerchantIdIsLoading > -1) {
        this.merchantIdListIsLoading.splice(indexMerchantIdIsLoading, 1);
      }
    }
  }

  public async SetFavoriteMerchantModel() {
    if (this.getFavoriteMerchantListLoadingStatus == LoadingStatusType.Success) {
      this.listFavoriteMerchant = [];
      this.listFilterFavoriteMerchant = [];
      for (const favoriteMerchant of this.getFavoriteMerchantList) {
        const merchantModel = await this.DoGetMerchantModelById(favoriteMerchant.merchantId);
        if (merchantModel) {
          this.listFavoriteMerchant.push(merchantModel);
        }
      }

      this.SetListFilter();
      this.ResetDatalistDisplay();
    }
  }

  public SetFavoriteMerchantForMerchantList() {
    this.listFilterFavoriteMerchantForMap = new Map();
    for (const filterFavoriteMerchant of this.listFilterFavoriteMerchant) {
      this.listDisplay.unshift({ ...filterFavoriteMerchant, isFavorite: true });
      this.listFilterFavoriteMerchantForMap.set(filterFavoriteMerchant.merchantId, filterFavoriteMerchant.merchantId);
    }
  }

  public CheckCanShowItem(merchant: any) {
    if (merchant.isFavorite) {
      return true;
    }

    if (!this.listFilterFavoriteMerchantForMap.get(merchant.merchantId)) {
      return true;
    }

    return false;
  }

  public ToggleFocus() {
    const children: any = this.$children[0];
    children.ToggleFocus();
  }

  public OpenInputSearch() {
    this.ToggleFocus();
  }
}
</script>

<style lang="scss" scoped>
#selectCompany {
  position: relative;
  .select {
    margin-left: 15px;
    .crop {
      @include crop(1, 300px);
    }
    .merchantName {
      color: white;
    }
    .merchantCode {
      display: flex;
      align-items: center;
      cursor: pointer;
      z-index: 200;
      width: fit-content;
      p,
      i {
        font-size: 12px;
        color: $gray_hover;
      }
      transition: 0.5s;
      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }
    }
    .peakageBox {
      margin-top: 5px;
      padding: 3px 15px 3px 3px;
      background: white;
      width: max-content;
      display: flex;
      align-items: center;
      border-radius: 25px;
      p {
        font-size: 12px;
      }
    }
    a {
      color: white;
      display: flex;
      justify-content: space-between;
      cursor: pointer;

      i {
        padding-left: 10px;
        font-size: 10px;
      }
    }
  }
  .buttonUpgard {
    position: absolute;
    right: -100px;
    background: linear-gradient(108deg, #ffb166 -0%, #f1502f 100%);
    margin-top: -28px;
    padding: 2px 17px;
    border-radius: 25px;
    @include shadowboxLv2;
    p {
      color: white;
    }
  }
  .dropdowns {
    position: absolute;
    background-color: white;
    z-index: 3;
    top: 5px;
    margin-left: -10px;
    width: 420px;
    border-radius: 6px;
    @include shadowboxLv2;
    .overflow {
      overflow: hidden;
      padding-bottom: 64px;
    }
    .selectThis {
      position: relative;
      border-bottom: 0.5px solid #e5e5e5;
      .iconArrow {
        position: absolute;
        right: 16px;
        top: 10px;
        width: unset;
        i {
          font-size: 10px;
        }
      }
    }
    .selectList {
      max-height: 256px;
      overflow: auto;
      .allcompany {
        cursor: pointer;
        padding: 16px;
        border-top: 0.5px solid #e5e5e5;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: white;
      }
      .companyItem {
        &:hover {
          background: $hover;
        }
      }
    }

    .companyItem {
      height: 80px;
      display: flex;
      align-items: center;
      padding: 16px 8px;
      cursor: pointer;
      transition: all 0.5 ease;

      .imgCompany {
        margin: 0px 16px 0px 8px;
        border-radius: 50%;
        height: 45px;
        width: 45px;
        background: white;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        img {
          max-height: 100%;
          max-width: 100%;
        }
      }

      .merchantName {
        width: 300px;
      }

      .merchantName-crop {
        @include crop(1, 290px);
      }
    }

    .otherInfo {
      margin-left: 8px;
      font-size: 12px;
      color: $textDisabled;
    }
  }

  .selectCompany {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.5 ease;

    .imgCompany {
      margin: 0px 16px;
      border-radius: 50%;
      height: 45px;
      width: 45px;
      background: white;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      img {
        max-height: 100%;
        max-width: 100%;
      }
    }

    .merchantName {
      width: 250px;
    }
  }

  .status {
    padding: 2px 10px;
    border-radius: 20px;
    font-size: 12px;
    color: white;
  }
  .peakage5,
  .peakage1 {
    background: #9d9eb1;
  }
  .peakage2 {
    background: #3297ff;
  }
  .peakage3,
  .peakage6 {
    background: #6c6df2;
  }
  .peakage4,
  .peakage0 {
    background: linear-gradient(to right, #6c6df2 0%, #44e5e6 100%);
  }

  .peakage7 {
    background: #3dc0cb;
  }

  .peakage8 {
    background: #3395fa;
  }

  .boxIn {
    animation-name: boxIn;
    animation-duration: 0.25s;
    animation-timing-function: ease-out;
  }
  .boxOut {
    animation-name: boxOut;
    animation-duration: 0.25s;
    animation-timing-function: ease-out;
  }
  .textIn {
    animation-name: textIn;
    animation-duration: 0.25s;
    animation-timing-function: ease-out;
  }
  .textOut {
    animation-name: textOut;
    animation-duration: 0.5s;
    animation-timing-function: ease-out;
  }

  .favorite {
    color: $yellow !important;
  }
  .favorite-hover {
    color: $textDisabled;
    &:hover {
      color: $yellow !important;
    }
  }
  .favorite-disable {
    color: $textDisabled;
  }
  .skeleton {
    display: flex;
    height: 80px;
    .img-skeleton {
      display: flex;
      justify-content: center;
      align-items: center;

      margin-right: 8px;
      > div {
        border-radius: 50%;
        overflow: hidden;
      }
    }
    width: 100%;
  }

  @keyframes boxIn {
    0% {
      max-height: 0px;
    }
    100% {
      max-height: 390px;
    }
  }
  @keyframes boxOut {
    from {
      max-height: 390px;
    }
    to {
      max-height: 0px;
    }
  }
  @keyframes textIn {
    from {
      transform: translateY(-10px);
    }
    to {
      transform: translateY(0px);
    }
  }
  @keyframes textOut {
    0% {
      transform: translateY(0px);
      opacity: 1;
    }
    50% {
      transform: translateY(-10px);
      opacity: 0;
    }
    100% {
      transform: translateY(-20px);
      opacity: 0;
    }
  }
}
</style>
